import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSignalMedium",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, _, f, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--signal-medium"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Signal Medium",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.5 10a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm3-2.5A.5.5 0 0 1 4 8v2a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Zm2.5-2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ s(c, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=signal-medium.js.map
